/* tslint:disable */
/* eslint-disable */
/**
 * SR AAT specification
 * Description
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AuthorizationStatus,
  RoleGroups,
  RoleGroupsResponse,
  Status,
} from '../models';
import {
    AuthorizationStatusFromJSON,
    AuthorizationStatusToJSON,
    RoleGroupsFromJSON,
    RoleGroupsToJSON,
    RoleGroupsResponseFromJSON,
    RoleGroupsResponseToJSON,
    StatusFromJSON,
    StatusToJSON,
} from '../models';

export interface GetRoleGroupsRequest {
    id: number;
    authorization?: string;
    onBehalfOf?: string;
}

export interface UpdateRoleGroupsRequest {
    id: number;
    roleGroups: RoleGroups;
    authorization?: string;
    onBehalfOf?: string;
}

/**
 * 
 */
export class RoleGroupAssignmentsApi extends runtime.BaseAPI {

    /**
     * Get role group assignments by role id.
     */
    async getRoleGroupsRaw(requestParameters: GetRoleGroupsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleGroupsResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getRoleGroups.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
            headerParameters['Authorization'] = String(requestParameters.authorization);
        }

        if (requestParameters.onBehalfOf !== undefined && requestParameters.onBehalfOf !== null) {
            headerParameters['On-Behalf-Of'] = String(requestParameters.onBehalfOf);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/role-groups/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleGroupsResponseFromJSON(jsonValue));
    }

    /**
     * Get role group assignments by role id.
     */
    async getRoleGroups(requestParameters: GetRoleGroupsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleGroupsResponse> {
        const response = await this.getRoleGroupsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update role group assignments by role id.
     */
    async updateRoleGroupsRaw(requestParameters: UpdateRoleGroupsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Status>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateRoleGroups.');
        }

        if (requestParameters.roleGroups === null || requestParameters.roleGroups === undefined) {
            throw new runtime.RequiredError('roleGroups','Required parameter requestParameters.roleGroups was null or undefined when calling updateRoleGroups.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
            headerParameters['Authorization'] = String(requestParameters.authorization);
        }

        if (requestParameters.onBehalfOf !== undefined && requestParameters.onBehalfOf !== null) {
            headerParameters['On-Behalf-Of'] = String(requestParameters.onBehalfOf);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/role-groups/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: RoleGroupsToJSON(requestParameters.roleGroups),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StatusFromJSON(jsonValue));
    }

    /**
     * Update role group assignments by role id.
     */
    async updateRoleGroups(requestParameters: UpdateRoleGroupsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Status> {
        const response = await this.updateRoleGroupsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
